import MessengerBody from "./MessengerBody";

export default MessengerBody;
